var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 455.886,
    height: 417.68,
    viewBox: "0 0 455.886 417.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20083",
    "data-name": "Group 20083",
    transform: "translate(-5.042 -12.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44322",
    "data-name": "Path 44322",
    d: "M149.9,111.15a87.757,87.757,0,0,0-25.751,6.528c-3.36,1.44-7.2,4.2-6.432,7.752s4.8,4.632,5.76,7.776a8.455,8.455,0,0,1-.7,5.136c-1.128,3.216-3.384,7.2-6.768,6.5-2.208-.336-3.816-2.688-6.048-2.688a4.56,4.56,0,0,0-4.344,3.552,11.74,11.74,0,0,0,.384,6.048,68.565,68.565,0,0,0,14.231,27.311Z",
    transform: "translate(140.484 137.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44323",
    "data-name": "Path 44323",
    d: "M124.721,117.25a12.185,12.185,0,0,0-7.2,6.192,6.989,6.989,0,0,0,2.712,7.584,8.261,8.261,0,0,1,2.688,3.384,10.026,10.026,0,0,1-1.44,6.264c-.72,1.368-1.776,3.24-3.408,3.672s-3.192-1.1-4.608-1.9a5.421,5.421,0,0,0-7.488,1.56c-2.52,3.84-.576,8.544.6,12.7a70.194,70.194,0,0,0,13.511,24c1.128,1.344,3.024-.576,1.92-1.872A67.228,67.228,0,0,1,108.4,153.273a11.494,11.494,0,0,1-.576-6.72,2.867,2.867,0,0,1,.458-1.018,2.9,2.9,0,0,1,.814-.763,2.869,2.869,0,0,1,1.044-.391,2.818,2.818,0,0,1,1.116.036c.768.192,1.44.96,4.56,2.4a6.263,6.263,0,0,0,6.96-3.024,14.655,14.655,0,0,0,2.976-9.384c-.432-2.952-2.952-4.44-4.8-6.528-6.84-7.7,19.439-13.535,29.759-14.615,1.68-.168,1.728-2.88,0-2.712a91.559,91.559,0,0,0-25.991,6.7Z",
    transform: "translate(139.578 136.585)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44324",
    "data-name": "Path 44324",
    d: "M187.839,106.626c-18.935-.816-38.542,3.552-53.854,14.735s-25.775,29.735-24.647,48.694c1.008,17.135,10.824,32.447,21.6,45.958Z",
    transform: "translate(145.888 130.962)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44325",
    "data-name": "Path 44325",
    d: "M188.575,106.014c-35.735-.72-67.7,15.047-77.613,47.038-7.2,24.287,3.984,44.686,19.8,64.509,1.1,1.368,3-.552,1.92-1.92-13.2-16.535-25.1-36.671-19.967-58.654,6.408-27.359,34.8-50.4,75.885-48.286a1.34,1.34,0,0,0,.948-.4,1.361,1.361,0,0,0,.286-.439,1.308,1.308,0,0,0,.1-.516,1.359,1.359,0,0,0-.108-.514,1.271,1.271,0,0,0-.3-.432,1.294,1.294,0,0,0-.437-.288,1.315,1.315,0,0,0-.516-.1Z",
    transform: "translate(145.153 130.206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44326",
    "data-name": "Path 44326",
    d: "M118.23,163.487a86.722,86.722,0,0,0,5.976-25.895c.288-3.648-.408-8.352-3.96-9.264s-6.312,2.208-9.6,1.56a8.3,8.3,0,0,1-4.224-2.976c-2.4-2.4-4.8-6.24-2.712-8.976,1.344-1.8,4.152-2.16,5.4-4.08a4.609,4.609,0,0,0-1.176-5.4,12.027,12.027,0,0,0-5.4-2.4,68.206,68.206,0,0,0-30.815.144Z",
    transform: "translate(93.342 127.931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44327",
    "data-name": "Path 44327",
    d: "M120.364,164.639a90.293,90.293,0,0,0,6-25.607,13.8,13.8,0,0,0-1.44-8.568,6.363,6.363,0,0,0-7.536-2.4,17.249,17.249,0,0,1-4.8,1.368c-2.088,0-3.7-1.968-4.944-3.456a8.014,8.014,0,0,1-2.4-5.016c0-2.088,2.4-2.712,3.816-3.624a5.424,5.424,0,0,0,2.04-7.368c-2.016-3.552-5.952-4.3-10.008-5.064a70.01,70.01,0,0,0-29.015.7c-1.68.384-.96,3,.72,2.688a66.355,66.355,0,0,1,30.5,0A7.931,7.931,0,0,1,108.364,111c2.4,3.72-3.048,4.656-4.8,6.84a6.864,6.864,0,0,0,.48,8.112,12.853,12.853,0,0,0,7.2,6.168c4.392.5,4.8-1.872,9.288-1.632,2.712.7,3.048,4.44,3.024,6.744a76.527,76.527,0,0,1-5.976,26.735C117,165.527,119.548,166.367,120.364,164.639Z",
    transform: "translate(92.505 127.019)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44328",
    "data-name": "Path 44328",
    d: "M67.03,184.639c-2.928,4.608,1.416,11.16,6.792,12,11.544,1.752,25.247-15.767,19.919-29.279Z",
    transform: "translate(85.457 216.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44329",
    "data-name": "Path 44329",
    d: "M67.455,194.336a10.815,10.815,0,0,0,9.792,4.44c8.76-.768,15.671-9.024,18.407-16.8a21.072,21.072,0,0,0,0-14.255c-.6-1.608-3.216-.912-2.688.744,5.64,15-11.448,31.991-20.759,26.783-3.1-1.7-5.4-5.76-3.5-9.144a1.381,1.381,0,0,0-2.4-1.368,9.456,9.456,0,0,0,1.152,9.6Z",
    transform: "translate(84.624 215.35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44330",
    "data-name": "Path 44330",
    d: "M33.02,120.539a7.8,7.8,0,0,1-8.592-6.936,11.807,11.807,0,0,1,5.9-10.8,26.838,26.838,0,0,1,12-3.432c8.112-.7,17.5.744,21.263,7.847Z",
    transform: "translate(27.119 120.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44331",
    "data-name": "Path 44331",
    d: "M33.281,119.98c-5.16.528-8.472-5.376-6.168-10.1s7.368-7.056,12.312-7.968c7.872-1.392,19.2-1.3,23.735,6.72.84,1.536,3.168.168,2.4-1.368-4.3-7.68-13.967-9.144-21.959-8.4A26.736,26.736,0,0,0,29.2,103.4a12.721,12.721,0,0,0-5.232,11.64,9.119,9.119,0,0,0,10.344,7.536c1.7-.264.984-2.88-.72-2.712Z",
    transform: "translate(26.402 119.984)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44332",
    "data-name": "Path 44332",
    d: "M89.81,98.078a85.849,85.849,0,0,0,18.287,19.2c2.928,2.256,7.2,4.272,9.912,1.824s1.632-6.528,3.96-8.832a8.806,8.806,0,0,1,4.8-1.92c3.36-.552,7.848-.5,9.024,2.712.744,2.112-.5,4.632.48,6.672a4.609,4.609,0,0,0,5.256,2.04,12.128,12.128,0,0,0,5.04-3.264,68.352,68.352,0,0,0,16.8-25.8Z",
    transform: "translate(118.667 108.815)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44333",
    "data-name": "Path 44333",
    d: "M89.495,99.439A96,96,0,0,0,107.3,118.495c2.712,2.088,6,4.32,9.6,3.768s4.8-3.768,5.4-6.84a5.4,5.4,0,0,1,2.424-4.128,13.609,13.609,0,0,1,5.856-1.1,6.358,6.358,0,0,1,4.008,1.008c1.632,1.392.672,3.984.792,5.808a5.4,5.4,0,0,0,5.736,5.064c4.3-.264,7.2-3.528,10.008-6.672a71.325,71.325,0,0,0,14.4-23.519c.6-1.632-2.016-2.4-2.688-.72A68.014,68.014,0,0,1,151.124,111.3c-1.248,1.44-2.4,2.712-3.84,4.128a13.361,13.361,0,0,1-4.8,3.576,3.314,3.314,0,0,1-4.3-1.392c-.648-1.776.288-3.888-.168-5.712-1.44-5.856-10.608-5.16-14.687-3-3.12,1.68-3.24,4.8-4.272,7.92-1.392,4.08-5.4,2.712-8.28.864A81.426,81.426,0,0,1,91.775,97.928C90.815,96.632,88.343,97.856,89.495,99.439Z",
    transform: "translate(117.806 108.126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44334",
    "data-name": "Path 44334",
    d: "M76.94,82.546c8.568,16.8,21.935,31.871,39.214,39.718s38.567,7.823,54.526-2.4c14.4-9.288,22.919-25.343,29.351-41.254Z",
    transform: "translate(100.65 91.877)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44335",
    "data-name": "Path 44335",
    d: "M123.206,126.891c21.6,7.2,45.358,2.184,60.478-15a109.2,109.2,0,0,0,18.479-32.183c.648-1.584-1.968-2.4-2.688-.7-7.848,19.367-19.343,39.358-40.558,45.958-27.191,8.375-61.63-5.28-80.037-42.262-.792-1.536-3.12-.192-2.4,1.392C77.919,85.925,91.863,116.739,123.206,126.891Z",
    transform: "translate(99.814 91.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44336",
    "data-name": "Path 44336",
    d: "M75.12,50.307c-2.256-4.968-9.96-4.968-13.607-.936-7.752,8.544-.888,29.711,13.607,32.759Z",
    transform: "translate(74.535 46.863)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44337",
    "data-name": "Path 44337",
    d: "M68.784,45.929a10.824,10.824,0,0,0-9.024,5.4c-4.44,7.656-1.248,18.311,3.84,24.863a21.073,21.073,0,0,0,11.856,7.944,1.4,1.4,0,1,0,.7-2.712C60.744,77.944,55.68,54.233,65.424,49.313a6.959,6.959,0,0,1,9.6,2.256c.744,1.584,3.072.192,2.4-1.368a9.335,9.335,0,0,0-8.64-4.272Z",
    transform: "translate(73.648 46.081)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44338",
    "data-name": "Path 44338",
    d: "M145.4,55.054a7.824,7.824,0,0,1,10.56-3.384,12,12,0,0,1,5.664,10.944,27.222,27.222,0,0,1-3.792,12c-3.816,7.2-10.272,14.207-18.263,13.535Z",
    transform: "translate(188.326 52.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44339",
    "data-name": "Path 44339",
    d: "M156.133,53.7c4.992,2.64,5.664,9.288,4.008,14.855-2.712,8.232-9.816,19.535-19.775,18.911a1.357,1.357,0,0,0,0,2.712c9.6.72,16.439-8.112,20.255-15.671,4.8-8.256,4.512-20.423-4.992-23.783a9.073,9.073,0,0,0-10.824,4.464c-.7,1.608,1.632,2.976,2.4,1.392C147.374,56.386,150.446,50.675,156.133,53.7Z",
    transform: "translate(187.626 52.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44340",
    "data-name": "Path 44340",
    d: "M168.974,131.384a64.3,64.3,0,0,0-11.568-40.558c-2.4-3.456-6.7-7.008-10.44-5.064-8.352,4.3.744,32.111-3.144,52.8Z",
    transform: "translate(193.552 101.116)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44341",
    "data-name": "Path 44341",
    d: "M157.42,90.83c-5.712-8.016-13.631-7.9-14.015,3.36a92.273,92.273,0,0,0,.648,16.8,12.671,12.671,0,0,1,20.735-7.1A46.446,46.446,0,0,0,157.42,90.83Z",
    transform: "translate(193.515 101.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44342",
    "data-name": "Path 44342",
    d: "M158.884,90.215a13.441,13.441,0,0,0-7.584-5.4,6.505,6.505,0,0,0-6.984,3.408,19.326,19.326,0,0,0-1.512,9.384c0,15.311,3.048,25.247.6,41.446-.24,1.7,2.4,2.4,2.712.72,1.728-9.456.912-18.887.216-28.343a11.232,11.232,0,0,1,18.023-5.952,63.488,63.488,0,0,1,4.152,26.711,1.368,1.368,0,0,0,2.712,0,65.828,65.828,0,0,0-12.336-41.974Zm-12.936,15.455c-.168-3.456-.168-7.056-.168-10.656,0-2.4.384-6,2.9-7.2,5.256-2.616,11.232,7.992,13.8,13.271a14.113,14.113,0,0,0-16.535,4.632Z",
    transform: "translate(192.747 100.406)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44343",
    "data-name": "Path 44343",
    d: "M142.888,149.78c-8.376,11.664-24.335,13.991-37.127,20.759a10.583,10.583,0,0,0-6.216,6.672c-.72,4.368,3.624,7.9,7.776,9.6a43.182,43.182,0,0,0,25.3.7,127.276,127.276,0,0,0,24-9.312Z",
    transform: "translate(132.186 191.508)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44344",
    "data-name": "Path 44344",
    d: "M107.319,178.441a54.186,54.186,0,0,0,21.143,1.728c-8.5-3.432-14.4-17.543-6.048-24.479-7.2,1.416-21.6,5.928-22.871,13.247C98.848,173.233,103.143,176.833,107.319,178.441Z",
    transform: "translate(132.188 199.781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44345",
    "data-name": "Path 44345",
    d: "M156.6,177.632a125.748,125.748,0,0,1-27.695,10.1,16.8,16.8,0,0,1-8.424-12,13.21,13.21,0,0,1,3.984-10.608c7.824-3.168,14.831-6.7,20.375-13.943,1.056-1.392-1.32-2.712-2.4-1.368-9,12.311-25.727,13.511-37.847,21.047A10.028,10.028,0,0,0,99,178.9a10.246,10.246,0,0,0,5.28,8.136c6.888,4.368,16.223,4.536,24,3.432,10.416-1.512,20.063-6.072,29.543-10.488C159.478,179.216,158.086,176.864,156.6,177.632ZM107.9,185.84c-2.712-1.248-6.528-3.744-6.312-7.2s4.464-5.64,7.368-7.056c3.48-1.728,7.08-3.12,10.68-4.536-3.984,6.744-.6,16.415,5.568,21.239a39.487,39.487,0,0,1-17.375-2.448Z",
    transform: "translate(131.532 190.775)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44346",
    "data-name": "Path 44346",
    d: "M126.358,154.644c26.255-46.558,81.717-65.277,123.811-41.566s55.2,80.781,28.8,127.459S197.252,305.814,155.085,282.1,100.1,201.322,126.358,154.644Z",
    transform: "translate(150.756 125.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44347",
    "data-name": "Path 44347",
    d: "M195.646,294.573a81.725,81.725,0,0,1-40.318-10.512c-42.742-24-55.918-82.029-29.351-129.283s82.965-66.141,125.731-42.094a84.286,84.286,0,0,1,40.8,55.99C306.426,231.047,257.084,294.573,195.646,294.573ZM128.449,156.1c-25.823,45.958-13.127,102.308,28.319,125.611a81.61,81.61,0,0,0,66.837,5.52c47.758-16.031,77.421-68.805,66.309-117.955a81.606,81.606,0,0,0-39.406-54.238c-41.71-23.3-96.452-4.9-122.3,41.062Z",
    transform: "translate(150.081 124.952)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44348",
    "data-name": "Path 44348",
    d: "M259.992,163.906c-.744-6.7-8.568-12.36-14.4-9.6,8.9-6.1,9.432-21.6.408-27.959-9.456-6.6-24.887.216-26.4,11.664-.768-7.872-11.352-10.968-18.6-8.112a23.255,23.255,0,0,0-14.4,23.639,15.792,15.792,0,0,0-15.479,25.991,20.765,20.765,0,0,0-17.375,12,14.4,14.4,0,0,0,7.44,18.167c-4.8-2.136-12.312,11.16-13.175,14.087-2.4,7.776,7.2,6.36,10.656,4.248-5.28,3.216-8.064,10.728-4.8,15.959,3.072,4.8,11.4,4.8,14.159.24l-4.2,9.456a7.207,7.207,0,0,0-.72,6.024,6.406,6.406,0,0,0,5.424,2.568,30.779,30.779,0,0,0,24.383-10.248,6.218,6.218,0,0,0,4.56,7.416c4.056.792,7.992-1.7,11.376-4.08a44.515,44.515,0,0,0,13.079-12c3.048-5.064,3.984-12,.36-16.8,8.136-.96,16.8-4.3,20.663-11.5s.264-18.359-7.848-19.2a79.938,79.938,0,0,0,15.935-12.744C256.224,177.922,260.808,171.154,259.992,163.906Z",
    transform: "translate(199.611 155.087)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44349",
    "data-name": "Path 44349",
    d: "M261.92,163.673a13.581,13.581,0,0,0-11.5-10.656,20.308,20.308,0,0,0,2.4-20.855c-6.264-13.391-26.759-11.112-32.519,2.16a15.081,15.081,0,0,0-13.3-6.072,23.761,23.761,0,0,0-21.023,24.479,17.111,17.111,0,0,0-16.559,26.855c-7.2,1.512-13.967,6-16.391,13.1a15.841,15.841,0,0,0,5.208,16.967,28.28,28.28,0,0,0-8.5,9.888,15.407,15.407,0,0,0-2.688,7.08,5,5,0,0,0,4.512,5.064,13.707,13.707,0,0,0,2.976,0c-3.24,4.8-4.1,11.352.48,15.479a10.844,10.844,0,0,0,10.512,1.92c-2.4,5.232-4.656,9.144-2.544,12.384a7.851,7.851,0,0,0,6.24,2.688,30.166,30.166,0,0,0,23.135-8.088,8.615,8.615,0,0,0,12,4.8,55.447,55.447,0,0,0,12.624-8.352,27.111,27.111,0,0,0,8.664-11.16,15.441,15.441,0,0,0-.36-12.864c8.616-1.512,18.311-5.736,20.855-14.735,1.9-6.576-.792-14.687-7.008-17.519a66.245,66.245,0,0,0,20.015-19.487,19.459,19.459,0,0,0,2.76-13.079Zm-3.432,8.088a36.3,36.3,0,0,1-9.288,12.96,92.394,92.394,0,0,1-13.967,10.824,1.342,1.342,0,0,0-.454.641,1.346,1.346,0,0,0,.4,1.447,1.345,1.345,0,0,0,.722.312c6.984.96,9.48,9.984,7.392,15.767-2.88,7.992-12.552,11.352-20.207,12.312a1.32,1.32,0,0,0-1.176.665,1.346,1.346,0,0,0-.175.679,1.33,1.33,0,0,0,.2.672,13.1,13.1,0,0,1,.84,13.151,28.8,28.8,0,0,1-9.6,10.824c-1.944,1.44-3.936,2.88-6,4.2a14.4,14.4,0,0,1-7.2,2.712,4.8,4.8,0,0,1-4.8-5.688c.432-.5.84-1.008,1.224-1.536.816-1.08-.744-2.712-1.824-1.824a5.081,5.081,0,0,0-1.3,1.392,30.045,30.045,0,0,1-22.367,10.68c-1.848,0-4.944,0-5.928-1.944s1.176-5.712,2.064-7.68c.12-.312,3.264-7.344,3.624-8.328.456-1.416-1.848-2.4-2.4-1.032l-.864,1.944c-2.4,3.192-7.992,3.048-10.752.384-4.584-4.44-1.152-12.168,3.408-15.1a1.381,1.381,0,0,0-1.368-2.4,10.177,10.177,0,0,1-7.2,1.32c-2.712-.648-1.9-3.48-1.008-5.4a40.236,40.236,0,0,1,4.944-7.92c1.224-1.488,3.744-4.8,6.048-3.888,1.392.528,2.4-1.848,1.008-2.4a13.222,13.222,0,0,1-7.032-15.983c2.256-6.84,9.6-10.824,16.223-11.664a1.367,1.367,0,0,0,.814-.2,1.367,1.367,0,0,0,.17-2.2,14.4,14.4,0,0,1,14.111-23.879,1.331,1.331,0,0,0,1.19-.214,1.337,1.337,0,0,0,.538-1.082,22.341,22.341,0,0,1,12.264-21.815c5.784-2.712,17.135-1.9,18.1,6.192.168,1.344,2.4,2.016,2.712.336,1.224-8.376,9.984-13.991,18.167-13.152,8.784.912,13.272,9.84,11.832,17.951a14.6,14.6,0,0,1-7.2,10.728,1.353,1.353,0,0,0-.638.818,1.311,1.311,0,0,0-.036.528,1.325,1.325,0,0,0,.17.5,1.369,1.369,0,0,0,1.848.5,8.4,8.4,0,0,1,10.728,2.016,12.006,12.006,0,0,1,2.04,12.864Z",
    transform: "translate(198.811 154.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44350",
    "data-name": "Path 44350",
    d: "M151.269,126.471A21.334,21.334,0,0,0,133.1,156.542c.7,1.608,3.024.216,2.4-1.344a18.673,18.673,0,0,1,15.887-25.967,1.381,1.381,0,0,0-.12-2.76Z",
    transform: "translate(176.627 158.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44351",
    "data-name": "Path 44351",
    d: "M191.9,125.215c5.4.48,9.264-6.36,7.536-11.5-3.7-10.944-25.511-15.263-35.183-4.32Z",
    transform: "translate(222.876 126.076)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44352",
    "data-name": "Path 44352",
    d: "M200.963,121.663a11.064,11.064,0,0,0-1.152-10.824c-4.92-7.032-15.143-9.216-23.183-8.112a21.069,21.069,0,0,0-12.551,6.432c-1.176,1.3.72,3.216,1.92,1.92,10.512-11.592,33.167-4.656,33.167,5.832,0,3.72-2.4,7.9-6.6,7.68a1.368,1.368,0,0,0,0,2.712,9.143,9.143,0,0,0,8.4-5.64Z",
    transform: "translate(222.114 125.26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44353",
    "data-name": "Path 44353",
    d: "M150.564,189.271a7.8,7.8,0,0,1-2.4,10.824,11.991,11.991,0,0,1-12-.48,26.782,26.782,0,0,1-8.616-9.192c-4.272-6.744-7.2-15.887-2.688-22.463Z",
    transform: "translate(164.564 216.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44354",
    "data-name": "Path 44354",
    d: "M150.4,190.62a6.574,6.574,0,0,1-3.456,9.84c-4.992,1.8-10.08-1.056-13.511-4.656-5.9-6.312-12.192-18.071-6.672-26.4.96-1.44-1.392-2.712-2.4-1.344-5.424,8.112-1.008,18.455,3.912,25.607a22.652,22.652,0,0,0,10.536,9.12,12,12,0,0,0,12.36-1.992,9.075,9.075,0,0,0,1.416-11.568c-1.056-1.392-3.384,0-2.4,1.344Z",
    transform: "translate(163.551 216.281)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44355",
    "data-name": "Path 44355",
    d: "M83.09,171.223a64.218,64.218,0,0,0,38.974,15.983c4.248.216,9.6-.936,10.44-5.088,1.872-9.36-25.559-19.2-39.55-35.159Z",
    transform: "translate(109.259 187.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44356",
    "data-name": "Path 44356",
    d: "M82.847,172.908c13.1,11.568,30.071,16.8,42.43,16.367a11.519,11.519,0,0,0,7.872-3.1,6.745,6.745,0,0,0,.456-8.112,29.729,29.729,0,0,0-8.112-7.56c-11.04-8.232-18.935-11.376-30.719-23.639-1.152-1.32-3.048.6-1.92,1.9,9.432,10.824,22.391,17.015,33.455,25.751,2.4,1.824,6.312,4.608,5.784,8.112-.432,2.688-3.792,3.72-6.144,3.984-10.7.768-28.151-4.2-41.038-15.575-1.3-1.152-3.216.768-1.92,1.9Z",
    transform: "translate(108.518 186.811)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44357",
    "data-name": "Path 44357",
    d: "M78.087,136.148C71.511,123.357,76.791,108,76.6,93.622a10.487,10.487,0,0,0-3.072-8.568c-3.552-2.688-8.688-.408-12,2.712a43.2,43.2,0,0,0-12.216,22.151A131.7,131.7,0,0,0,46.6,135.4Z",
    transform: "translate(58.177 99.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44358",
    "data-name": "Path 44358",
    d: "M79.987,136.284c-5.52-11.016-2.256-24.839-1.56-36.6a27.5,27.5,0,0,0-.768-11.016,7.655,7.655,0,0,0-7.032-5.4,13.919,13.919,0,0,0-9.072,3.816,41.279,41.279,0,0,0-12,19.391A113.591,113.591,0,0,0,46,136.02a1.368,1.368,0,0,0,2.712,0c.576-15.239,1.3-32.447,12.168-44.4a15.912,15.912,0,0,1,8.328-5.4c3.864-.768,6.048,2.088,6.576,5.568,1.44,14.4-5.568,31.2,1.824,45.91.792,1.536,3.12.192,2.4-1.392Z",
    transform: "translate(57.332 98.4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44359",
    "data-name": "Path 44359",
    d: "M128.365,207.682c9.408-16.487,14.4-36,11.544-54.622s-14.591-36.647-32.039-44.278c-15.7-6.936-33.791-5.184-50.59-1.8Z",
    transform: "translate(73.128 127.438)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44360",
    "data-name": "Path 44360",
    d: "M130.32,209.037c17.159-30.143,18.167-66.261-5.9-90.308-18.263-17.807-41.83-17.3-66.717-12.288-1.728.312-1.008,2.928.7,2.688,20.975-4.176,44.566-5.4,61.75,9.456,24.575,21.359,25.487,58.846,7.824,89.133a1.387,1.387,0,1,0,2.4,1.392Z",
    transform: "translate(72.325 126.611)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44361",
    "data-name": "Path 44361",
    d: "M92.8,71.61A64.078,64.078,0,0,0,58,95.369c-2.4,3.552-4.536,8.544-1.512,11.664,6.72,6.48,30.383-10.9,51.094-13.7Z",
    transform: "translate(69.935 82.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44362",
    "data-name": "Path 44362",
    d: "M93.271,71.179a64.8,64.8,0,0,0-36,24.767,13.441,13.441,0,0,0-2.856,8.856,6.48,6.48,0,0,0,5.76,5.784,23.112,23.112,0,0,0,10.464-2.04c13.343-4.656,20.423-9.84,38.063-13.151,1.7-.24.984-2.688-.72-2.688-14.663,2.064-27.455,9.912-41.422,14.207-2.712.84-7.2,2.136-9.024-.96-1.488-2.712.36-6.12,1.824-8.3A62.878,62.878,0,0,1,93.919,73.818a1.392,1.392,0,0,0,.984-1.7,1.44,1.44,0,0,0-1.632-1.1Z",
    transform: "translate(69.103 81.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44363",
    "data-name": "Path 44363",
    d: "M126.57,95.363c14.255,1.608,24.335,14.4,36.311,22.2a10.3,10.3,0,0,0,8.832,2.136c4.2-1.488,5.136-7.032,4.464-11.4a43.2,43.2,0,0,0-11.76-22.415A128.451,128.451,0,0,0,144.593,69.66Z",
    transform: "translate(170.127 79.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44364",
    "data-name": "Path 44364",
    d: "M127.322,97.482c11.376,1.32,20.231,10.416,29.159,17.351a43.5,43.5,0,0,0,9.768,6.48,8.3,8.3,0,0,0,9.6-1.392,12.6,12.6,0,0,0,2.688-9.072c-2.064-19.2-16.8-30.383-32.447-41.47-1.392-1.032-2.688,1.32-1.344,2.4,12.936,9.048,27.695,19.871,30.743,36.574a12.3,12.3,0,0,1-1.152,9.12c-2.544,3.6-7.008,1.632-9.984-.24-13.223-8.376-19.8-19.487-36.983-22.391C125.571,94.578,125.619,97.266,127.322,97.482Z",
    transform: "translate(169.375 78.596)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44365",
    "data-name": "Path 44365",
    d: "M160.556,19.07c53.542,0,96.956,39.238,96.956,87.621s-43.414,87.6-96.956,87.6S63.6,155.073,63.6,106.691,107.062,19.07,160.556,19.07Z",
    transform: "translate(81.975 8.526)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44366",
    "data-name": "Path 44366",
    d: "M161.4,196.415c-54.214,0-98.4-39.91-98.4-88.941S107.11,18.51,161.4,18.51s98.4,39.91,98.4,88.965S215.658,196.415,161.4,196.415Zm0-175.193c-52.8,0-95.612,38.686-95.612,86.253s42.934,86.253,95.612,86.253,95.612-38.71,95.612-86.253S214.194,21.222,161.4,21.222Z",
    transform: "translate(81.135 7.742)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44367",
    "data-name": "Path 44367",
    d: "M232.171,37.048c5.328,6.552,8.856,14.4,14.135,20.855s12.912,12,21.311,11.712c-9.912,9.984-24.791,13.9-38.783,12.839s-27.359-6.6-39.622-13.223c-8.112-4.392-16.031-9.6-21.119-17.231A67.893,67.893,0,0,1,59.93,71.679c18.7-2.808,28.8-23.447,40.1-35.135a69.766,69.766,0,0,1,46.942-21c8.3-.312,12.96,2.4,18.575,7.92,1.248-6.6,9.12-9.6,15.839-9.84a64.458,64.458,0,0,1,50.782,23.423Z",
    transform: "translate(76.837 0.892)",
    fill: "#f15223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44368",
    "data-name": "Path 44368",
    d: "M268.534,69.187c-7.92.216-14.735-4.68-19.679-10.488-5.592-6.6-9.288-14.567-14.567-21.407-9.048-11.664-24-20.9-42.886-23.783-9.36-1.416-21.791-.408-25.679,8.208A23.159,23.159,0,0,0,148.3,14.949a70.724,70.724,0,0,0-45.886,18.935C88.8,46.628,79.949,67.987,60.366,71.155a1.392,1.392,0,0,0-.6,2.4,68.805,68.805,0,0,0,47.446,19.2,69.981,69.981,0,0,0,61.774-37.439,54.444,54.444,0,0,0,14.831,12.672c20.015,12,42.6,21.023,65.109,15A44.355,44.355,0,0,0,269.4,71.515a1.392,1.392,0,0,0-.864-2.328ZM230.783,82.074c-15.215-.864-29.591-7.536-42.67-14.735a55.475,55.475,0,0,1-18-15.263,1.367,1.367,0,0,0-2.4,0A66.6,66.6,0,0,1,63.63,73.243C80.189,69.187,89,52.8,99.388,40.94a70.94,70.94,0,0,1,43.534-22.919,32.972,32.972,0,0,1,12.648.5,25.028,25.028,0,0,1,9.888,6.648,1.368,1.368,0,0,0,2.256-.6c3.5-16.223,45.934-9.6,64.173,14.063,5.64,7.2,9.6,15.839,15.7,22.727a29.684,29.684,0,0,0,17.591,10.344A49.172,49.172,0,0,1,230.783,82.074Z",
    transform: "translate(75.946 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44369",
    "data-name": "Path 44369",
    d: "M97.443,69.763a21.384,21.384,0,0,0,34.871,1.416c1.032-1.368-.864-3.288-1.92-1.9a18.672,18.672,0,0,1-30.647-.864C98.811,66.955,96.483,68.3,97.443,69.763Z",
    transform: "translate(129.033 76.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44370",
    "data-name": "Path 44370",
    d: "M19.382,173.9C19.574,119.778,52.6,70.82,97.835,48.4c1.584-.768.192-3.1-1.368-2.4A145.891,145.891,0,0,0,16.67,173.9a1.368,1.368,0,0,0,1.344,1.368,1.391,1.391,0,0,0,1.368-1.368Z",
    transform: "translate(16.278 46.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44371",
    "data-name": "Path 44371",
    d: "M30.211,112.235a94.652,94.652,0,0,1,50.4-55.054c1.608-.7.216-3.024-1.344-2.4a96.908,96.908,0,0,0-51.67,56.854c-.552,1.656,2.04,2.4,2.712.744Z",
    transform: "translate(31.464 58.372)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44372",
    "data-name": "Path 44372",
    d: "M167.359,80.152a114.4,114.4,0,0,1,17.519,52.63c.12,1.728,2.832,1.776,2.688,0a115.191,115.191,0,0,0-19.559-56.47,31.478,31.478,0,0,0-11.3-10.368c-1.584-.744-2.952,1.584-1.392,2.4a31.937,31.937,0,0,1,12.048,11.808Z",
    transform: "translate(209.4 73.944)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44373",
    "data-name": "Path 44373",
    d: "M157.519,59.761a123.955,123.955,0,0,1,41.614,96.308,1.344,1.344,0,1,0,2.688,0,126.5,126.5,0,0,0-42.382-98.228C158.119,56.689,156.2,58.705,157.519,59.761Z",
    transform: "translate(212.832 62.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44374",
    "data-name": "Path 44374",
    d: "M84.552,179.245a144.14,144.14,0,0,0,73.005.48,1.4,1.4,0,0,0,1-1.716,1.407,1.407,0,0,0-1.716-1,138.064,138.064,0,0,1-71.685-.5,1.4,1.4,0,0,0-.546-.01,1.35,1.35,0,0,0-.509.2,1.4,1.4,0,0,0-.046,2.328,1.376,1.376,0,0,0,.5.218Z",
    transform: "translate(109.765 228.881)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44375",
    "data-name": "Path 44375",
    d: "M79.933,185.144A116.61,116.61,0,0,0,157.81,188.6a1.4,1.4,0,0,0-.7-2.712,112.935,112.935,0,0,1-76.485-3.528c-1.584-.648-2.4,1.944-.7,2.712Z",
    transform: "translate(103.513 236.973)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44376",
    "data-name": "Path 44376",
    d: "M23.456,161.265c-20.975,12.288-25.607,46.918-2.184,58.2,10.056,4.512,21.791,1.608,32.255-1.9,4.944-1.68,10.824-3.288,14.9,0,3.672-5.76,0-13.535-4.8-18.335s-10.8-9.216-12.7-15.791c-1.3-4.464-.432-9.264-1.056-13.9C48.079,156.346,33.871,155.674,23.456,161.265Z",
    transform: "translate(0.804 202.942)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44377",
    "data-name": "Path 44377",
    d: "M61.794,195.513c-3.456-3.264-7.2-6.768-8.76-11.5-1.632-5.232,0-10.8-1.56-16.223-4.056-13.775-23.231-12.983-34.175-2.4a41.137,41.137,0,0,0-12,24.671c-2.4,19.319,12.215,36.191,31.895,33.6a74.9,74.9,0,0,0,16.415-3.72c4.416-1.464,10.536-3.96,14.711-.72a1.34,1.34,0,0,0,1.121.386,1.323,1.323,0,0,0,.571-.209,1.341,1.341,0,0,0,.42-.442C75.594,210.248,67.818,201.225,61.794,195.513ZM46.771,219.08c-8.9,2.4-18.935,3.408-27.047-1.8-15.383-10.344-15-31.2-4.128-45.982,12.263-16.8,33.6-13.128,33.935,3.168a39.922,39.922,0,0,0,.672,9.408c2.4,8.592,9.432,12.216,14.567,18.455,3.12,3.792,5.808,9.192,3.888,13.943C61.962,212.6,53.419,217.376,46.771,219.08Z",
    transform: "translate(0 202.245)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44378",
    "data-name": "Path 44378",
    d: "M50.814,112.158c40.486-26.639,97.028-12,126.523,32.639s20.639,102.524-19.751,129.187-97.028,12-126.523-32.711S10.423,138.8,50.814,112.158Z",
    transform: "translate(12.037 120.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44379",
    "data-name": "Path 44379",
    d: "M30.7,242.858C.864,197.6,9.864,138.822,50.83,111.8s98.54-12.167,128.4,33.095S200.033,248.93,159.09,275.953C117.356,303.456,59.974,287.161,30.7,242.858Zm21.6-128.8c-39.718,26.207-48.382,83.3-19.367,127.2s84.957,58.51,124.651,32.327,48.382-83.3,19.367-127.2S92.061,87.969,52.318,114.055Z",
    transform: "translate(11.276 119.453)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44380",
    "data-name": "Path 44380",
    d: "M42.931,118.755C53.755,109.563,64.363,99.82,79.482,99.82a22.087,22.087,0,0,0-12,13.031c-4.56,13.3,8.112,25.127,11.856,37.559,4.8,15.983,4.08,31.055,2.88,47.374,41.95-.432,47.038,4.8,85.8,23.135a39.562,39.562,0,0,0,15.647,4.8,14.714,14.714,0,0,0,13.847-7.2c-2.712,5.424-2.136,13.775-4.44,19.727a50.392,50.392,0,0,1-11.28,18c-32.423,32.447-74.229,39.958-110.084,26.639C5.613,257.062-11.282,165.385,42.931,118.755Z",
    transform: "translate(7.775 121.569)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44381",
    "data-name": "Path 44381",
    d: "M196.9,218.841c-1.68,4.464-9.024,8.136-17.663,5.712-6.84-1.9-10.7-4.56-22.847-10.176C130.9,201.85,117.873,196.618,84.275,197.29c1.08-14.9,1.848-30.023-2.4-44.59-4.488-15.215-14.015-23.015-13.223-34.247a20.253,20.253,0,0,1,12.408-16.8c1.272-.552.576-2.543-.672-2.4-15.479.144-27.359,10.415-38.4,20.111-45.31,39.958-41.254,113.42,5.184,151,33.431,26.807,79.413,26.855,114.476,5.016,8.28-5.136,19.2-13.463,25.343-21.119a50.585,50.585,0,0,0,10.44-27.215,24.6,24.6,0,0,1,1.824-6.888C199.95,218.649,197.814,217.137,196.9,218.841Zm-3.048,13.487c-2.76,16.439-13.991,27-26.855,36.311C133.9,293.023,88.522,296.6,53.484,271.927,11.246,242,.686,182.579,27.085,140.484A114.917,114.917,0,0,1,57.876,109.79a39.974,39.974,0,0,1,16.367-7.2,22.3,22.3,0,0,0-5.808,28.079c4.656,10.464,12.743,18.071,13.607,40.414a191.356,191.356,0,0,1-.624,27.5,1.366,1.366,0,0,0,1.368,1.344c41.158-1.008,51.118,6.72,86.2,23.519,8.232,4.152,18.311,6.816,25.991,1.464a49.979,49.979,0,0,0-1.128,7.416Z",
    transform: "translate(7.063 120.767)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44382",
    "data-name": "Path 44382",
    d: "M85.431,145.951A21.335,21.335,0,0,0,67.264,116a1.344,1.344,0,0,0,0,2.688A18.7,18.7,0,0,1,83.2,144.631c-.7,1.584,1.632,2.976,2.4,1.368Z",
    transform: "translate(85.223 144.219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44383",
    "data-name": "Path 44383",
    d: "M94.279,87.929A16.439,16.439,0,1,0,77.84,71.49,16.439,16.439,0,0,0,94.279,87.929Z",
    transform: "translate(101.91 58.895)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44384",
    "data-name": "Path 44384",
    d: "M134.509,87.579A16.439,16.439,0,1,0,118.07,71.14,16.44,16.44,0,0,0,134.509,87.579Z",
    transform: "translate(158.228 58.405)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44385",
    "data-name": "Path 44385",
    d: "M95.012,53a8.5,8.5,0,1,0,3.259.64A8.495,8.495,0,0,0,95.012,53Z",
    transform: "translate(114.089 56.025)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44386",
    "data-name": "Path 44386",
    d: "M124.3,52.93a8.519,8.519,0,1,0,6.009,2.5,8.516,8.516,0,0,0-6.009-2.5Z",
    transform: "translate(154.994 55.927)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44387",
    "data-name": "Path 44387",
    d: "M178.618,131.591a16.44,16.44,0,1,0-19.494,12.669A16.44,16.44,0,0,0,178.618,131.591Z",
    transform: "translate(197.458 138.249)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44388",
    "data-name": "Path 44388",
    d: "M142.729,179.639A16.439,16.439,0,1,0,126.29,163.2,16.44,16.44,0,0,0,142.729,179.639Z",
    transform: "translate(169.735 187.28)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44389",
    "data-name": "Path 44389",
    d: "M159.844,122.37a8.522,8.522,0,1,0,6,2.5A8.523,8.523,0,0,0,159.844,122.37Z",
    transform: "translate(204.747 153.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44390",
    "data-name": "Path 44390",
    d: "M145.29,147.74a8.521,8.521,0,1,0,6.024,2.5A8.52,8.52,0,0,0,145.29,147.74Z",
    transform: "translate(184.406 188.652)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44391",
    "data-name": "Path 44391",
    d: "M87.369,166.2A16.439,16.439,0,1,0,70.93,149.759,16.44,16.44,0,0,0,87.369,166.2Z",
    transform: "translate(92.236 168.465)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44392",
    "data-name": "Path 44392",
    d: "M61.659,135.249A16.439,16.439,0,1,0,45.22,118.809,16.44,16.44,0,0,0,61.659,135.249Z",
    transform: "translate(56.245 125.138)",
    fill: "rgba(254,169,0,0.48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44393",
    "data-name": "Path 44393",
    d: "M75.22,135.81a8.521,8.521,0,1,0,6.024,2.5,8.521,8.521,0,0,0-6.024-2.5Z",
    transform: "translate(86.315 171.951)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44394",
    "data-name": "Path 44394",
    d: "M56.674,113.21a8.521,8.521,0,1,0,6,2.5,8.524,8.524,0,0,0-6-2.5Z",
    transform: "translate(60.319 140.313)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/Values.b2b2709b0bc98c2f35ae2e4e0d19e2e8.svg";
export { ForwardRef as ReactComponent };